import { Trans } from '@lingui/macro';
import { observer } from 'mobx-react-lite';
import React, { FC, useContext, useState, useEffect } from 'react';
import { Button, Form, Toast } from 'react-bootstrap';
import ReactQuill from 'react-quill';
import { Context } from '../..';
import UserService from '../../services/UserService';
import { formats, modules } from './modal/QuillSettings';


const Feedback: FC = () => {
    const { store } = useContext(Context);
    const [data, setData] = useState<any>({});
    const [message, setMessage] = useState('');
    const [showToast, setShowToast] = useState(false);
    const [toastInfo, setToastInfo] = useState('');
    const email = store.user.email;

    useEffect(() => {
        setData({ ...data, 'message': message })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [message]);

    useEffect(() => {
        setData({ ...data, 'email': email })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const createQA: any = async () => {
        try {
            await UserService.createFeedback(data);
            setToastInfo(store.lang === 'ba' ? 'Эшләнде' : store.lang === 'ru' ? 'Сделано' : 'Done');
            setShowToast(true);
        } catch (e) {
            setToastInfo(store.lang === 'ba' ? 'Ебәреү хаталы' : store.lang === 'ru' ? 'Ошибка отправки' : 'Sending error');
            setShowToast(true);
            console.log(e);
        }
    };

    return (
        <div>
            {store.user.is_active ?
                <Form className='row m-5'>

                    <Form.Group className="mb-3" controlId="formMessage">
                        <Form.Label><Trans>Message</Trans></Form.Label>
                        <ReactQuill
                            theme="snow"
                            modules={modules}
                            formats={formats}
                            onChange={setMessage} />
                    </Form.Group>

                    <Form.Group className="col-md-6 mb-3">
                        <Button variant="primary" type="button" onClick={() => createQA()}>
                            <Trans>Send</Trans>
                        </Button>
                    </Form.Group>

                    <Toast className='toast p-0 border-success' bg='light' onClose={() => setShowToast(false)} show={showToast} delay={5000} autohide>
                        <Toast.Header className='bg-success m-0 text-light'>
                            <strong className="me-auto"><Trans>Information</Trans></strong>
                        </Toast.Header>
                        <Toast.Body><strong>{toastInfo}</strong></Toast.Body>
                    </Toast>

                </Form>
                : <div className='m-5 text-center'><Trans>To feedback, please log in.</Trans></div>}
        </div>
    )
};
export default observer(Feedback);